import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MaybeCopilotWrapper({
  children,
  copilotEnabled,
  CopilotCollaborationContextProviderComponent
}) {
  if (copilotEnabled) {
    if (CopilotCollaborationContextProviderComponent) {
      children = /*#__PURE__*/_jsx(CopilotCollaborationContextProviderComponent, {
        children: children
      });
    }
    return /*#__PURE__*/_jsx(CopilotProvider, {
      children: children
    });
  }
  return children;
}